import axios from 'axios';

import { getAuthToken } from '@providers/AuthProvider';
import { ApiEndpoints } from '@utils/endpoints';

// TODO replace with confirmAppointment.ts and remove when no longer in use
export const confirmAppointment = async (appointmentId: string): Promise<boolean> => {
	const authorizationToken = await getAuthToken();
	try {
		const response = await axios.post<{ appointmentConfirmed: boolean }>(
			`${ApiEndpoints.cogsworthConfirmAppointment}/${appointmentId}`,
			{},
			{
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					authorizationToken,
				},
			}
		);
		return response.data.appointmentConfirmed;
	} catch (error: any) {
		console.warn(`Error confirming appointment ${appointmentId}: ${error}`);
		return false;
	}
};
